var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSquareFoot = function SvgSquareFoot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M216-144q-30 0-51-21t-21-51v-555q0-15 14-21t25 5l102 102-39 39 34 34 39-39 90 90-39 39 34 34 39-39 90 90-39 39 34 34 39-39 91 91-39 39 34 34 39-39 95 95q11 11 5 25t-21 14zm24-96h354L240-594z"
  })));
};
export default SvgSquareFoot;